module.exports = __webpack_public_path__ + "static/media/lifedrain.e4c9ac3e.png";